export const getTestimonials = ({
  testimonialReducer: { testimonials = [] } = {},
}) => testimonials;
export const getTestimonialsFilter = ({
  testimonialReducer: { filter = {} } = {},
}) => filter;
export const getTestimonialsCount = ({
  testimonialReducer: { count = 0 } = {},
}) => count;
